<script lang="ts">
    import {onMount} from "svelte";
    import fromEntityStore, {descriptionFromEntityStore} from "$lib/utils/fromEntityStore";
    import {getDispo} from "$lib/calls/dispo";

    export let project: any;


    onMount(() => {

    })
    $: percentage = parseInt(descriptionFromEntityStore(project, 'assignedCount') || 0) / parseInt(descriptionFromEntityStore(project, 'jobSize') || 0);
</script>

<span class="inline-flex whitespace-nowrap items-center rounded-full {percentage < 0.75 ? 'bg-red-400' : (percentage < 1 ? 'bg-yellow-400' : 'bg-green-400')} px-2 py-1 text-xs font-medium text-white ring-1 ring-inset ring-gray-500/10">{descriptionFromEntityStore(project, 'assignedCount') || 0} | {descriptionFromEntityStore(project, 'jobSize') || 0}</span>